module.exports = __webpack_public_path__ + "static/media/view5.42a0363f.jpg";